export default "__VITE_ASSET__Cj5dF9jt__"